import { dataMarketSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMarketSolid = /*#__PURE__*/createIcon(dataMarketSolid)
export default IconMarketSolid
